
import type { IBrokerPlugin, IBrokerContext, IBrokerPluginContext } from '@source-digital/sd-app-broker'
import { Broker$ExperienceResourceApi, ExperienceResourceApi } from './resources'
import { type ResourceApiOptions, ResourceApiContext } from './resources/common'

export interface ResourceApiConfig {
  params?: ResourceApiOptions
}

export interface ResourceApiPluginConfig extends ResourceApiConfig {
  baseUrl: string
}

export interface ExperienceResourceApiPlugin extends IBrokerPlugin {
  api?: ExperienceResourceApi
  brokerApi?: Broker$ExperienceResourceApi
}

export function experienceResourceApiPlugin (config: ResourceApiPluginConfig): ExperienceResourceApiPlugin {
  return {

    id: '@source-digital/sd-app-plugin-experience-api',
    api: undefined,
    brokerApi: undefined,
    async install (ctx: IBrokerPluginContext): Promise<void> {
      const context = new ResourceApiContext(ctx, config.baseUrl, config?.params)
      this.api = new ExperienceResourceApi(context)
      ctx.apis.register(this.id, this.api)
      this.brokerApi = new Broker$ExperienceResourceApi(context)
    },
    async uninstall (ctx: IBrokerContext): Promise<void> {
      ctx.rootMessenger.unregisterApi(this.id)
      if (this.api != null) this.api.destroy()
      if (this.brokerApi != null) this.brokerApi.destroy()
    }
  }
}
